export const UserLoginStatsGtmAfterSavePopupImpression = {
  event: 'User Interaction',
  eventAction: 'Impression:Login to see saved properties',
};
